import { render, staticRenderFns } from "./alarm-setting-dialog.vue?vue&type=template&id=e427c666&scoped=true&"
import script from "./alarm-setting-dialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./alarm-setting-dialog.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./alarm-setting-dialog.vue?vue&type=style&index=0&id=e427c666&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e427c666",
  null
  
)

/* custom blocks */
import block0 from "./alarm-setting-dialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports